export default __webpack_public_path__ + "static/media/modal_cross_icon_white.4cca94b4.svg";